import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  h6 {
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: #171b20;
  }

  .document-tiles {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    flex-wrap: wrap;

    .document-tile {
      flex: 1;
      cursor: pointer;
      border-radius: 4px;
      border: solid 1px #c2c9cf;
      margin: 5px;

      &.active {
        background-color: ${({ theme }) => theme.colors.primary.shades['96']};
        border: solid 1px ${({ theme }) => theme.colors.primary.color};
      }

      &:hover {
        /* color: ${({ theme }) => theme.colors.primary.color}; */
        background-color: ${({ theme }) => theme.colors.primary.shades['96']};
      }

      /* &.active.drl {
        background-color: #eaf0fe;
        border: solid 1px #346ffe;
      }

      &.active.idc {
        background-color: #e5fbf2;
        border: solid 1px #00da84;
      }

      &.active.pst {
        background-color: #feeded;
        border: solid 1px #ff3737;
      } */

      &-inner {
        min-width: 150px;
        height: 100%;
        padding: 20px;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: space-between;

        div:first-child {
          margin-right: 16px;
        }

        div.text {
          width: 100%;
        }

        span.document-tile-text {
          display: block;
          text-align: center;
        }
      }
    }
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    .document-tiles {
      flex-direction: column;
      margin-top: 24px;

      .document-tile {
        width: 100%;
        margin-bottom: 16px;

        border: solid 1px ${({ theme }) => theme.colors.gray.color};

        .document-tile-inner {
          margin: 0 0;
          width: 100%;

          .isvg.loaded {
            margin: 16px;
          }
          .vertical-center.text {
            font-family: Roboto;
            font-size: 16px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.5;
            letter-spacing: normal;
            color: #182445;
          }
        }
        span.document-tile-text {
          display: block;
          text-align: center;

          padding-right: 80px;
          &.icon{
            padding-right: 0px;
          }
        }
      }
    }
  }
`;
